export default "__VITE_ASSET__D7x_xdJA__"